import { UpdateOrganizationKycSettingDto } from '@dealstack/shared/lib/generated';
import { KycSettings } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/KycSettings/types.ts';
import {
	IndividualInvestorSettings,
	InvestmentVehicleSettings,
} from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/InvestorData/types.ts';

export type Column = keyof UpdateOrganizationKycSettingDto;

/** The columns a toggle can write — every one of them is a boolean, unlike `certificationText`. */
export type BooleanColumn = {
	[K in Column]-?: NonNullable<UpdateOrganizationKycSettingDto[K]> extends boolean ? K : never;
}[Column];

/** Each screen's toggle keys mapped to the KycSetting column they write. */
export const KYC_COLUMNS: Record<keyof KycSettings, BooleanColumn> = {
	kycRequired: 'isKycRequired',
	proofOfIdentityRequired: 'isProofOfIdentityRequired',
	proofOfAddressRequired: 'isProofOfAddressRequired',
	proofOfInvestmentVehicleRequired: 'isProofOfInvestmentVehicleRequired',
	proofOfIdentityCertificationRequired: 'isProofOfIdentityCertificationRequired',
	proofOfAddressCertificationRequired: 'isProofOfAddressCertificationRequired',
	proofOfInvestmentVehicleCertificationRequired:
		'isProofOfInvestmentVehicleCertificationRequired',
	beneficialOwnershipRequired: 'isBeneficialOwnershipRequired',
	sourceOfFundsRequired: 'isSourceOfFundsRequired',
	pepRequired: 'isPepRequired',
};

export const INDIVIDUAL_COLUMNS: Record<keyof IndividualInvestorSettings, BooleanColumn> = {
	bankAccountDetails: 'isInvestorBankAccountRequired',
	taxResidence: 'isTaxResidenceRequired',
	taxIdentificationNumber: 'isTinRequired',
	placeOfBirth: 'isPlaceOfBirthRequired',
	countryOfBirth: 'isCountryOfBirthRequired',
	employeeId: 'isEmployeeIdRequired',
	citizenship: 'isCitizenshipRequired',
};

export const VEHICLE_COLUMNS: Record<keyof InvestmentVehicleSettings, BooleanColumn> = {
	bankAccountDetails: 'isVehicleBankAccountRequired',
	controllingPartyInfo: 'isControllingPartyInfoRequired',
};
